import React from "react";
import { FolderIcon } from "../icons/SvgIcons";
import { emptyStateClasses } from "../styles/componentClasses";

export function EmptyState({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className={emptyStateClasses.wrapper}>
      <div className={emptyStateClasses.iconWrap}>
        <FolderIcon className={emptyStateClasses.icon} />
      </div>
      <h3 className={emptyStateClasses.title}>{title}</h3>
      {subtitle && <p className={emptyStateClasses.subtitle}>{subtitle}</p>}
      {action && <div className={emptyStateClasses.action}>{action}</div>}
    </div>
  );
}
